export const infoOutlinedIcon = require("../assets/information.png");
export const calendarIcon = require("../assets/calendarIcon.png");
export const groupIcon = require("../assets/groupIcon.png");
export const ownershipIcon = require("../assets/ownershipIcon.png");
export const smartTvIcon = require("../assets/smart-tv.png");
export const nextIconWhite = require("../assets/nextIconWhite.png");
export const nextIconBlack = require("../assets/nextIconBlack.png");
export const comingSoonIcon = require("../assets/comingSoon.png");